import React, { useContext, useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { StoreContext } from '../../Library/contexts';
import PATHS from '../../Routes/paths';
import "./style.css";

const DriverFlow = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // Redirect to Select Bus on initial load
        if (location.pathname === PATHS.DRIVER_ROUTE_CHECK || location.pathname === `${PATHS.DRIVER_ROUTE_CHECK}/`) {
            navigate(PATHS.SELECT_BUS, { replace: true });
        }
    }, [location, navigate]);

    return (
        <div className="driver-flow-container">
            <Outlet />
        </div>
    );
};

export default DriverFlow;
